import PaginateModel from "@/model/paginate";
import User, { UserCustomer, UserDTO } from "@/model/user";
import { AxiosResponse } from "axios";
import api, { ApiResponse } from "./api";

interface RequestInterface {
  meta: string;
  data: {
    data: UserDTO[];
    paginate: any;
  };
}

interface AuthResponse {
  success: string;
  meta: string;
  data: any;
}
interface AuthRequest {
  login_id: string;
  password: string;
}
interface ForgotRequest {
  login_id: string;
  email: string;
}
interface ResetPasswordRequest {
  password: string;
  password_confirmation: string;
}
interface UsersNew {
  login_id: string;
  password: string;
  name: string;
  email: string;
}
interface ChangePasswordRequest {
  login_password: string;
  login_password_confirmation: string;
}
interface UserList {
  list: User[];
  paginate: PaginateModel;
}

interface UserInfo {
  name: string;
  mail_address: string;
  login_id: string;
  login_password: string;
}

class UserApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAllUsers(query): Promise<UserList> {
    const response = await this.getHttp().get<RequestInterface>("admin/users", {
      params: query,
    });
    const list: User[] = [];
    response.data.data.data.map((userDto) => list.push(new User(userDto)));
    const paginate = new PaginateModel(response.data.data.paginate.Users);
    return {
      list: list,
      paginate: paginate,
    };
  }

  async getListUserSameCustomerCode(): Promise<User[]> {
    const response = await this.getHttp().get<RequestInterface>(
      "customer/users",
      {
        data: {
          notLoading: true,
        },
      }
    );
    const list: User[] = [];
    response.data.data.data.map((userDto) => list.push(new User(userDto)));

    return list;
  }

  async getCustomers(query): Promise<UserList> {
    const response = await this.getHttp().get("accounts", {
      params: query,
    });
    const result = response.data.data;

    const list: UserCustomer[] = [];
    result.data.map((userDto) => {
      list.push(new UserCustomer(userDto));
    });

    const paginate = new PaginateModel({
      page: result.pagination.current_page,
      pageCount: result.pagination.last_pages,
      start: result.pagination.current_page,
      end: result.pagination.last_pages,
      count: result.pagination.total,
    });

    return {
      list: list,
      paginate: paginate,
    };
  }

  async getRepresentativeCustomersList(query): Promise<UserList> {
    const response = await this.getHttp().get<RequestInterface>(
      "admin/representative-customers",
      {
        params: query,
      }
    );
    const list: User[] = [];
    response.data.data.data.map((userDto) => list.push(new User(userDto)));
    const paginate = new PaginateModel(response.data.data.paginate.Users);
    return {
      list: list,
      paginate: paginate,
    };
  }

  async login(data: AuthRequest): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>("/auth/login", data);
  }
  async refreshToken(): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/auth/refresh-token");
  }
  async logout(): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/auth/logout");
  }
  async forgotPassword(data: ForgotRequest): Promise<any> {
    const response = await this.getHttp().post<any>("/forgot-password", data);

    return response.data;
  }
  async verifyToken(token: string): Promise<any> {
    const response = await this.getHttp().get<ApiResponse>(
      "/verify-token/" + token
    );

    return response.data;
  }
  async resetPassword(token, data: ResetPasswordRequest): Promise<any> {
    const response = await this.getHttp().post<ApiResponse>(
      "/reset-password/" + token,
      data
    );

    return response.data;
  }
  async changePassword(data: ChangePasswordRequest): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>("/user/change-password", data);
  }
  async add(data: UsersNew): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>("/admin/users", data);
  }
  async delete(id): Promise<AxiosResponse> {
    return this.getHttp().delete<AuthResponse>("/admin/users/" + id);
  }
  async getUserCustomers(parameters): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/accounts/", parameters);
  }
  async getUserCustomer(id, parameters): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/accounts/" + id, parameters);
  }
  async deleteUserCustomer(accountCode): Promise<AxiosResponse> {
    return this.getHttp().delete<AuthResponse>("/accounts/" + accountCode);
  }
  async getImportHistory(): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/admin/get-import-history", {
      data: {
        notLoading: true,
      },
    });
  }
  async editRepresentativeCustomer(data: UsersNew): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>(
      "/admin/edit-representative-customer",
      data
    );
  }
  async editUserCustomer(id, data: User): Promise<AxiosResponse> {
    return this.getHttp().put<AuthResponse>(`/accounts/${id}`, data);
  }
  async addUserCustomer(data: User): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>(`/accounts`, data);
  }
  async me(): Promise<any> {
    const response = await this.getHttp().get<any>("/auth/me", {
      data: {
        notLoading: true,
      },
    });

    return response.data.data;
  }
  async updateUserInfo(data: UserInfo): Promise<AxiosResponse> {
    return this.getHttp().put<AuthResponse>(`/user`, data);
  }
}
export default new UserApi();
